module.exports = __webpack_public_path__ + "static/media/2.9eaf68a0.jpg";